import { RecapFile } from '../files/file';
import { authFetch } from '../util/api';
import { PartnerType } from './partner';

export async function getPartnerFile(workspaceId: string, partner: PartnerType, videoId: string) {
  const response = await authFetch(
    `/get_partner_videos?workspaceId=${workspaceId}&partner=${partner}&videoIds=${videoId}`,
  );
  return (response.files?.[0] || null) as RecapFile | null;
}

export function getRecapFile(workspaceId: string, fileId: string): Promise<RecapFile | undefined> {
  return authFetch(`/file_detail_get?fileId=${fileId}&workspaceId=${workspaceId}`);
}
